module.exports = __webpack_public_path__ + "img/SE5164047044.f7f382de.png";